import { render, staticRenderFns } from "./ProspectForm.vue?vue&type=template&id=64b57718&"
import script from "./ProspectForm.vue?vue&type=script&lang=js&"
export * from "./ProspectForm.vue?vue&type=script&lang=js&"
import style0 from "./ProspectForm.vue?vue&type=style&index=0&id=64b57718&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports